export default __webpack_public_path__ + "static/media/checked.6e2790c8.svg";